import { Injectable } from '@angular/core';
import { FlashService } from '@app/services/flash.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { ApiService } from '@app/services/api/api.service';
import {
  AddOne,
  AddOneFail,
  AddOneSuccess,
  BusinessUnitActionTypes,
  Create,
  CreateFail,
  CreateSuccess,
  DeleteOne,
  DeleteOneFail,
  DeleteOneSuccess,
  LoadByFollowIdFail,
  LoadByFollowIdSuccess,
  LoadFail,
  LoadSuccess
} from '@core/actions/business-unit.actions';

@Injectable()
export class BusinessUnitEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType(BusinessUnitActionTypes.Load),
    switchMap(action =>
      this.api.getBusinessUnits(action).pipe(
        map((businessUnits: any) => {
          return new LoadSuccess(businessUnits)
        }),
        catchError(error => of(new LoadFail(error)))
      )
    )
  );
  
  @Effect()
  loadByFollowId$: Observable<Action> = this.actions$.pipe(
    ofType(BusinessUnitActionTypes.LoadByFollowId),
    switchMap(action =>
      this.api.getBusinessUnitsbyId(action).pipe(
        map((businessUnits: any) => {
          return new LoadByFollowIdSuccess(businessUnits)
        }),
        catchError(error => of(new LoadByFollowIdFail(error)))
      )
    )
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType<Create>(BusinessUnitActionTypes.Create),
    switchMap(action => 
      this.api.createBusiness(action).pipe(
        map((data: any) => new CreateSuccess(data)),
        catchError(error => of(new CreateFail(error)))
      )
    )
  )

  @Effect({ dispatch: false })
  createFail$ = this.actions$.pipe(
    ofType<CreateFail>(BusinessUnitActionTypes.CreateFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo crear la unidad de negocio',
        type: 'danger'
      })
    )
  );

  @Effect({ dispatch: false })
  createSuccess$ = this.actions$.pipe(
    ofType<CreateSuccess>(BusinessUnitActionTypes.CreateSuccess),
    map(action => action.data),
    tap(res =>
      this.fs.emit({
        message: 'Creado con exito',
        type: 'success'
      })
    )
  );

  @Effect()
  addOne$: Observable<Action> = this.actions$.pipe(
    ofType<AddOne>(BusinessUnitActionTypes.AddOne),
    switchMap(action => 
      this.api.addBusiness(action).pipe(
        map((data: any) => new AddOneSuccess(data, action.data.FollowId)),
        catchError(error => of(new AddOneFail(error)))
      )
    )
  )

  @Effect({ dispatch: false })
  addOneFail$ = this.actions$.pipe(
    ofType<AddOneFail>(BusinessUnitActionTypes.AddOneFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo crear la unidad de negocio',
        type: 'danger'
      })
    )
  );

  @Effect({ dispatch: false })
  addOneSuccess$ = this.actions$.pipe(
    ofType<AddOneSuccess>(BusinessUnitActionTypes.AddOneSuccess),
    map(action => {
      this.fs.emit({
        message: 'Agregado con exito',
        type: 'success'
      })
    }),
  );

  @Effect()
  deleteOne$: Observable<Action> = this.actions$.pipe(
    ofType<DeleteOne>(BusinessUnitActionTypes.DeleteOne),
    switchMap(action => 
      this.api.deleteBusiness(action).pipe(
        map((data: any) => new DeleteOneSuccess(action.data.businessCountryId)),
        catchError(error => of(new DeleteOneFail(error)))
      )
    )
  )

  @Effect({ dispatch: false })
  DeleteOneFail$ = this.actions$.pipe(
    ofType<DeleteOneFail>(BusinessUnitActionTypes.DeleteOneFail),
    map(action => action.error),
    tap(res =>
      this.fs.emit({
        message: 'No se pudo eliminar la unidad de negocio',
        type: 'danger'
      })
    )
  );

  @Effect({ dispatch: false })
  deleteOneSuccess$ = this.actions$.pipe(
    ofType<DeleteOneSuccess>(BusinessUnitActionTypes.DeleteOneSuccess),
    map(action => {
      this.fs.emit({
        message: 'Eliminado con exito',
        type: 'success'
      })
    }),
  );

  constructor(
    private actions$: Actions, 
    private api: ApiService,
    private fs: FlashService
    ) {}
}
